export function formatPositionAge(positionTime: number | null, now = Date.now()): string {
  if (positionTime === null || !Number.isFinite(positionTime)) return 'Time unavailable'
  const ageSeconds = Math.max(0, Math.floor((now - positionTime) / 1_000))
  if (ageSeconds < 45) return 'Just now'

  const minutes = Math.floor(ageSeconds / 60)
  if (minutes < 60) return `${minutes} ${minutes === 1 ? 'min' : 'mins'} ago`

  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`

  const days = Math.floor(hours / 24)
  return `${days} ${days === 1 ? 'day' : 'days'} ago`
}
